import React from 'react'
import { roundWithLocale } from '@sketch/utils'
import {
  StopContainer,
  StopText,
  DotsBlurIcon,
  CircleIcon,
  StopValue,
} from './Blur.styles'

interface BlurStopProps {
  position: number
  radius: number
}

const Stop: React.FCC<
  BlurStopProps & { connected: boolean; first: boolean }
> = ({ position, radius, connected, first }) => {
  return (
    <StopContainer connected={connected}>
      <StopText>{roundWithLocale(position * 100, 0)}%</StopText>
      {first ? <CircleIcon /> : <DotsBlurIcon />}
      <StopValue> {roundWithLocale(radius * 100, 0)}</StopValue>
      <StopText> Blur</StopText>
    </StopContainer>
  )
}

export const BlurStops = ({ stops }: { stops: BlurStopProps[] }) => {
  const stopsLength = stops.length
  return (
    <>
      {stops.map((stop, index) => {
        const connected = stopsLength !== index + 1
        return (
          <Stop
            key={index}
            {...stop}
            first={index === 0}
            connected={connected}
          />
        )
      })}
    </>
  )
}
